module.exports = __webpack_public_path__ + "img/pctop.031fc9a7.png";